import { Popper, PopperProps } from '@mui/material';

const MenuItemPopper: React.FC<PopperProps> = ({ children, ...props }) => {
  return <Popper {...props}>{children}</Popper>;
};

export default MenuItemPopper;
